import React, { useEffect, useState } from 'react';
import axios from 'axios';
import RaceCard from './RaceCard';
import './RaceList.css';
import appConfig from '../config/config'; // Ajusta la ruta si es necesario

const RaceList = ({ eventCode , title }) => {
  const [races, setRaces] = useState([]);

  useEffect(() => {
    const fetchRaces = async () => {
      try {
        const response = await axios.post('https://wapi.cyclingfreestyle.com/api/Race', {
          eventCode: eventCode
        });
        setRaces(response.data);
      } catch (error) {
        console.error('Error al obtener carreras:', error);
      }
    };

    if (eventCode) {
      fetchRaces();
    }
  }, []);

  return (
    <div className='container-race-list'>
        {title && <h2>{title}</h2>}
    <div className="race-list">

      {races.map(race => (
        <RaceCard key={race._id || race.id} race={race} />
      ))}
    </div>
    </div>
  );
};

export default RaceList;

